export const getSanitizedSchedule = (schedules, isEmpty = false) => {
  return (JSON.parse(schedules) || []).reduce((acc, cur) => {
    return {...acc, [cur.date]: isEmpty ? [] : cur.time}
  }, {})
};

export const getSchedulesJSON = (schedule) => {
  const data = [];
  for (let key in schedule) {
    if (!schedule[key].length) continue;
    data.push({
      date: key,
      time: schedule[key]
    })
  }
  return data;
};

export const hasEmptyDays = (schedule) => {
  const hourSlots = Object.values(schedule);

  return hourSlots.length && hourSlots.some(el => !el.length);
};